<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17AmsTh/tc-custom/9781479854936.jpg?1721057644989" alt="This image is the cover for the book Facing the Rising Sun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Facing the Rising Sun
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The surprising alliance between Japan and pro-Tokyo African Americans during World War II </b><br/><br/>In November 1942 in East St. Louis, Illinois a group of African Americans engaged in military drills were eagerly awaiting a Japanese invasion of the U.S.— an invasion that they planned to join. Since the rise of Japan as a superpower less than a century earlier, African Americans across class and ideological lines had saluted the Asian nation, not least because they thought its very existence undermined the pervasive notion of “white supremacy.” The list of supporters included Booker T. Washington, Marcus Garvey, and particularly W.E.B. Du Bois. <br/><br/>Facing the Rising Sun tells the story of the widespread pro-Tokyo sentiment among African Americans during World War II, arguing that the solidarity between the two groups was significantly corrosive to the U.S. war effort. Gerald Horne demonstrates that Black Nationalists of various stripes were the vanguard of this trend—including followers of Garvey and the precursor of the Nation of Islam.  Indeed, many of them called themselves “Asiatic”, not African.  Following World War II, Japanese-influenced “Afro-Asian” solidarity did not die, but rather foreshadowed Dr. Martin Luther King’s tie to Gandhi’s India and Black Nationalists’ post-1970s fascination with Maoist China and Ho’s Vietnam. <br/><br/>Based upon exhaustive research, including the trial transcripts of the pro-Tokyo African Americans who were tried during the war, congressional archives and records of the Negro press, this book also provides essential background for what many analysts consider the coming “Asian Century.” An insightful glimpse into the Black Nationalists’ struggle for global leverage and new allies, Facing the Rising Sun provides a complex, holistic perspective on a painful period in African American history, and a unique glimpse into the meaning of “the enemy of my enemy is my friend.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gerald Horne
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af250534